import { Capacitor } from '@capacitor/core';
export const isApp = process.env.REACT_APP_BUILD_TARGET === 'app';
export const isWeb = !isApp;
export const isIos = isApp && Capacitor.getPlatform() === 'ios';
export const isAndroid = isApp && Capacitor.getPlatform() === 'android';
